import { useState } from "react";
import { api, apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Plus, Trash2, ArrowUp, ArrowDown } from "lucide-react";

export function CourseTabsDialog({ tabs, onClose, onSaved }) {
  const [list, setList] = useState(tabs.map((t) => ({ ...t, _rid: t.key })));
  const [busy, setBusy] = useState(false);
  const move = (i, dir) => setList((ts) => { const n = [...ts]; const j = i + dir; if (j < 0 || j >= n.length) return ts; [n[i], n[j]] = [n[j], n[i]]; return n; });
  const save = async () => {
    setBusy(true);
    try { await api.put("/short-term/tabs", { tabs: list.map(({ key, label }) => ({ key, label })) }); toast.success("Tabs saved"); onSaved(); onClose(); }
    catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="st-tabs-dialog" aria-describedby={undefined}>
        <DialogHeader><DialogTitle>Course tabs</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500">Rename, reorder, add or remove tabs. A tab can only be removed once it has no students.</p>
        <div className="space-y-2 max-h-[50vh] overflow-auto pr-1">
          {list.map((t, i) => (
            <div key={t._rid} className="flex items-center gap-2" data-testid={`st-tabrow-${i}`}>
              <input data-testid={`st-tab-label-${i}`} value={t.label} onChange={(e) => setList((ts) => ts.map((x, j) => (j === i ? { ...x, label: e.target.value } : x)))} className="flex-1 px-2.5 py-1.5 rounded-lg border border-slate-200 text-sm" />
              {t.count > 0 && <span className="text-[11px] text-slate-400 w-16">{t.count} student{t.count > 1 ? "s" : ""}</span>}
              <button type="button" onClick={() => move(i, -1)} className="p-1 text-slate-400 hover:text-slate-700"><ArrowUp className="h-4 w-4" /></button>
              <button type="button" onClick={() => move(i, 1)} className="p-1 text-slate-400 hover:text-slate-700"><ArrowDown className="h-4 w-4" /></button>
              <button type="button" data-testid={`st-tab-remove-${i}`} disabled={list.length === 1} onClick={() => setList((ts) => ts.filter((_, j) => j !== i))} className="p-1 text-slate-300 hover:text-rose-600 disabled:opacity-30"><Trash2 className="h-4 w-4" /></button>
            </div>
          ))}
        </div>
        <button type="button" data-testid="st-tab-add" onClick={() => setList((ts) => [...ts, { key: "", _rid: `new${Date.now().toString(36)}`, label: "New tab" }])} className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary"><Plus className="h-4 w-4" /> Add tab</button>
        <button data-testid="st-tabs-save" onClick={save} disabled={busy} className="w-full px-4 py-2.5 rounded-xl bg-primary text-white text-sm font-semibold disabled:opacity-60">{busy ? "Saving…" : "Save tabs"}</button>
      </DialogContent>
    </Dialog>
  );
}
